import React from "react"
import styled from "styled-components"
import { transform } from "typescript"

interface Props {
  isOpen: boolean
}

const IconTagsSelectionOpen: React.FC<Props> = ({ isOpen }) => {
  const style = {
    transition: "all 0.2s",
    ...(isOpen && { transform: "rotate(180deg)" }),
  } as React.CSSProperties // TypeScriptの型を明示的に指定

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect
        x="48"
        width="48"
        height="48"
        rx="24"
        transform="rotate(90 48 0)"
        fill={isOpen ? "#EF7A00" : "#F2F0EF"}
      />
      <path
        d="M30.3644 21.2928C30.1769 21.1053 29.9226 21 29.6574 21C29.3923 21 29.138 21.1053 28.9504 21.2928L24.0004 26.2428L19.0504 21.2928C18.8618 21.1106 18.6092 21.0098 18.347 21.0121C18.0848 21.0144 17.834 21.1196 17.6486 21.305C17.4632 21.4904 17.358 21.7412 17.3558 22.0034C17.3535 22.2656 17.4543 22.5182 17.6364 22.7068L23.2934 28.3638C23.481 28.5513 23.7353 28.6566 24.0004 28.6566C24.2656 28.6566 24.5199 28.5513 24.7074 28.3638L30.3644 22.7068C30.5519 22.5193 30.6572 22.265 30.6572 21.9998C30.6572 21.7346 30.5519 21.4803 30.3644 21.2928Z"
        fill={isOpen ? "white" : "#242424"}
      />
    </svg>
  )
}
const RotateWrapper = styled.div<{ isOpen: boolean }>`
  transition: all 0.5s;

  ${props => props.isOpen && "transform: rotate(-180deg);"};
`

export default IconTagsSelectionOpen
